import {
  createFetchRequest,
  errorResponse,
  FetchDataResponse,
  handleResponse,
} from 'utils/fetchData/fetchDataUtils';

export type StandardHTTPMethods = 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE';
type FetchOptions<T> =
  | {
      method: Extract<StandardHTTPMethods, 'GET' | 'DELETE'>;
      url: string;
      headers: Headers;
    }
  | {
      method: Extract<StandardHTTPMethods, 'POST' | 'PATCH' | 'PUT'>;
      url: string;
      headers: Headers;
      body: T;
    }
  | {
      method: Extract<StandardHTTPMethods, 'POST' | 'PUT'>;
      url: string;
      headers: Headers;
      file: File;
    };

const getRequestInit = <T>(options: FetchOptions<T>) => {
  if ('file' in options) {
    const formData = new FormData();
    formData.append('file', options.file);

    return {
      method: options.method,
      headers: options.headers,
      body: formData,
    };
  } else if ('body' in options) {
    return createFetchRequest(options.method, options.headers, options.body);
  } else {
    return { method: options.method, headers: options.headers };
  }
};

export const fetchData = async <B, R>(options: FetchOptions<B>): Promise<FetchDataResponse<R>> => {
  try {
    const response = await fetch(options.url, getRequestInit(options));
    return await handleResponse<R>(response);
  } catch (error) {
    return errorResponse(error);
  }
};
